const logLevel = {
    emerg: {
        color: 'error',
        icon: 'mdi-close-octagon',
        text: '障害'
    },
    alert: {
        color: 'error',
        icon: 'mdi-alert-decagram',
        text: '危険'
    },
    crit: {
        color: 'warning',
        icon: 'mdi-alert-decagram',
        text: '重大'
    },
    err: {
        color: 'error',
        icon: 'mdi-alert-circle',
        text: 'エラー'
    },
    warn: {
        color: 'warning',
        icon: 'mdi-alert',
        text: '警告'
    },
    notice:{
        color: 'primary',
        icon: 'mdi-checkbox-marked-circle-outline',
        text: '重要'
    },
    info:{
        color: 'secondary',
        icon: 'mdi-information-outline',
        text: '情報'
    },
    debug:{
        color: 'disabledBack',
        icon: 'mdi-information',
        text: 'デバッグ'
    }
}

export default ({ app }, inject) => {
    inject('logLevel', logLevel);
}